import { useCallback } from 'react';

import { FilePreviewStore } from '../store/file-preview.store';
import { TreeSpaceRef } from '../types/data-room.types';

/**
 * Open one file of a workspace or a data room in the viewer — 20.2.3.
 *
 * It used to fetch the bytes and hand them to the browser: a type the browser could draw opened in
 * a tab of its own, and everything else was saved to disk instead. That meant a Word document, the
 * format diligence is actually done in, could not be read in the product at all. The viewer draws
 * every format now, so this only says which file; what it takes to show it — a conversion, a
 * cache, a renderer — belongs to the overlay and the route behind it.
 *
 * The six screens that open a file all call this, so they all gained the viewer unchanged.
 */
export const useViewSpaceFile = () => {
  const open = FilePreviewStore(({ open }) => open);

  return useCallback(
    async ({
      fileId,
      fileName,
      space,
    }: {
      fileId: string;
      fileName: string;
      space: TreeSpaceRef;
    }) => {
      open({ fileId, fileName, space });
    },
    [open],
  );
};
